export const form = {
  formCopyLink: 'Kopiera länk',
  formLinkCopied: 'Länk kopierad!'
}
